import { combineReducers } from '@reduxjs/toolkit';
// ---- external imports ----

import turnReducer from './turn/reducer';
import characterReducer from './character/reducer';
import customerReducer from './customers/reducer';
import storeReducer from './store/reducer';
import employeesReducer from './employees/reducer';
import productsReducer from './products/reducer';
import logbookReducer from './logbook/reducer';
import levelReducer from './level/reducer';
import hintsReducer from './hints/reducer';
import gameReducer from './game/reducer';
import uiReducer from './ui/reducer';
import adsReducer from './ads/reducer';
import financialStatementsReducer from './financial-statements/reducer';
import warehouseReducer from './warehouses/reducer';
import carReducer from './cars/reducer';
import inboxReducer from './inbox/reducer';
import tradeshowsReducer from './tradeshows/reducer';
import playerHealthReducer from './playerHealth/reducer';
import loadingReducer from './loading/reducer';
import { GAME_RESET } from './game/actionTypes';
import { CheckpointReducerEnhancer } from './checkpoint';
// ---- internal imports ----


const combinedReducers = combineReducers({
	turn: turnReducer,
	character: characterReducer,
	employees: employeesReducer,
	customers: customerReducer,
	store: storeReducer,
	level: levelReducer,
	products: productsReducer,
	logbook: logbookReducer,
	game: gameReducer,
	ui: uiReducer,
	ads: adsReducer,
	financialStatements: financialStatementsReducer,
	hints: hintsReducer,
	cars: carReducer,
	warehouses: warehouseReducer,
	inbox: inboxReducer,
	tradeshows: tradeshowsReducer,
	playerHealth: playerHealthReducer,
	loading: loadingReducer,
});

const appReducer = CheckpointReducerEnhancer(combinedReducers);

const rootReducer = (state, action) => {
	if (action.type === GAME_RESET) {
		return appReducer(undefined, action);
	}

	return appReducer(state, action);
};


export { rootReducer };

